import { call, put, takeEvery, takeLatest } from "redux-saga/effects"
import {
  LOGIN_USER,
  LOGOUT_USER,
  FETCH_ALLOWED_MODULES_REQUEST,
} from "./actionTypes"
import {
  apiError,
  loginSuccess,
  logoutUserSuccess,
  fetchAllowedModulesSuccess,
  fetchAllowedModulesFailure,
} from "./actions"
import { getFirebaseBackend } from "../../../helpers/firebase_helper"
import { LoginAPI, ModuleAllowedApi } from "./api"

const fireBaseBackend = getFirebaseBackend()

function* loginUser({ payload: { user, history } }) {
  try {
    const response = yield call(LoginAPI, {
      username: user.userName,
      sid: user.sid,
      password: user.password,
    })
    if (response.status >= 200 || response.status <= 299) {
      yield put(loginSuccess(response.data))
      console.log(response.data)
      history("/dashboard")
    } else {
      throw response
    }
  } catch (error) {
    yield put(apiError(error || "Login Failed, Please try again"))
  }
}

function* logoutUser({ payload: { history } }) {
  try {
    localStorage.removeItem("authUser")
    localStorage.removeItem("Token")

    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      const response = yield call(fireBaseBackend.logout)
      yield put(logoutUserSuccess(response))
    }
  } catch (error) {
    yield put(apiError(error))
  }
}

function* fetchModuleAsync() {
  try {
    const response = yield call(ModuleAllowedApi);
    yield put(fetchAllowedModulesSuccess(response))
  } catch (error) {
    yield put(fetchAllowedModulesFailure(error))
  }
}

function* authSaga() {
  yield takeEvery(LOGIN_USER, loginUser)
  yield takeEvery(LOGOUT_USER, logoutUser)
  yield takeEvery(FETCH_ALLOWED_MODULES_REQUEST, fetchModuleAsync)
}

export default authSaga
